<template>
  <div v-if="visible" class="custom-dialog-overlay" @click="closeDialog">
    <div class="custom-dialog" @click.stop>
      <div class="dialog-header">
        <span>{{ title }}</span>
        <button class="close-button" @click="closeDialog">🗙</button>
      </div>
      <div class="dialog-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '对话框'
  }
});

const emit = defineEmits(['update:visible']);

const closeDialog = () => {
  emit('update:visible', false);
};
</script>

<style scoped>
.custom-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.custom-dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: 30%;
  max-width: 400px;
  padding: 1rem;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.dialog-header span {
  font-size: 1.25rem;
  font-weight: bold;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
}

.dialog-content {
  padding: 1rem 0;
}
</style>
